import {Product, ProductProvider} from "@irati/types"
import ProductType from "@irati/deals/types/enums/ProductType"
import ExternalSupplier from "@irati/deals/types/enums/ExternalSupplier"

export const isExternal = (product: Partial<Product>) => product.type === ProductType.External

export const isExternalAndOpenValue = (product: Partial<Product>) => isExternal(product) && product.data?.externalMetadata?.openValue

export const isExternalAndFixedValue = (product: Partial<Product>) =>
  isExternal(product) && product.data?.externalMetadata?.openValue === false

export const isWeGiftProduct = (product: Partial<Product>) => {
  return isExternal(product) && product.supplier === ExternalSupplier.WeGift
}

export const isDigitalGlueProduct = (product: Partial<Product>) => {
  return isExternal(product) && product.supplier === ExternalSupplier.DigitalGlue
}

export const isMeritProduct = (product: Partial<Product>) => {
  return isExternal(product) && product.provider === ProductProvider.Meritgc
}

export default isExternal
